import api from "./api";

export const dashboardService = {
  /**
   * Get dashboard statistics for a project
   */
  getProjectDashboardStats: async (projectId) => {
    const response = await api.get("/dashboard/stats", {
      params: { project_id: projectId },
    });
    return response.data;
  },
};
